import { Badge } from '@/components/ui/badge';
import { CheckCircle, Clock, XCircle } from 'lucide-react';
import { cn } from '@/lib/utils';

export type PersonStatus = 'bekreftet' | 'planlagt' | 'avvist' | 'ikke_svart';

interface StatusBadgeProps {
  status: PersonStatus;
  count?: number;
  className?: string;
}

const STATUS_CONFIG = {
  bekreftet: {
    icon: CheckCircle,
    label: 'Bekreftet',
    className: 'bg-status-confirmed/10 text-status-confirmed border-status-confirmed/30',
  },
  planlagt: {
    icon: Clock,
    label: 'Avventer',
    className: 'bg-status-waiting/10 text-status-waiting border-status-waiting/30',
  },
  ikke_svart: {
    icon: Clock,
    label: 'Avventer',
    className: 'bg-status-waiting/10 text-status-waiting border-status-waiting/30',
  },
  avvist: {
    icon: XCircle,
    label: 'Avvist',
    className: 'bg-status-declined/10 text-status-declined border-status-declined/30',
  },
} as const;

export function StatusBadge({ status, count, className }: StatusBadgeProps) {
  const config = STATUS_CONFIG[status];
  const Icon = config.icon;
  
  return (
    <Badge 
      variant="outline" 
      className={cn('gap-1 font-semibold', config.className, className)}
    >
      <Icon className="h-3.5 w-3.5" />
      {count !== undefined ? count : config.label}
    </Badge>
  );
}

export function StatusBadgeWithLabel({ status, count, className }: StatusBadgeProps) {
  const config = STATUS_CONFIG[status];
  const Icon = config.icon;
  
  return (
    <Badge 
      variant="outline" 
      className={cn('gap-0.5 sm:gap-1 font-semibold px-2 py-0.5 sm:px-3 sm:py-1 shrink-0', config.className, className)}
    >
      <Icon className="h-3 w-3 sm:h-4 sm:w-4" />
      {count !== undefined && <span className="text-xs">{count}</span>}
      <span className="text-xs whitespace-nowrap">{config.label}</span>
    </Badge>
  );
}

